var _rect, _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 759,
    height: 1052,
    viewBox: "0 0 759 1052",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_5876)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_183_5876)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1052,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_183_5876",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1052
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1052H1920V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_183_5876)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1052H1920V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_183_5876",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1052
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1052H1920V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_183_5876)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1052H1920V0Z",
    fill: "#FFB600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_183_5876",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1921,
    height: 1053
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1921 0H0V1052.97H1921V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_183_5876)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0996 10.2278H165.181V498.698H12.0996V10.2278Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.181 10.2278H613.89V175.5H165.181V10.2278Z",
    fill: "#DB536A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.181 175.5H388.781V342.221H165.181V175.5Z",
    fill: "#EB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.181 331.977H388.781V498.698H165.181V331.977Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.776 175.5H613.89V342.221H388.776V175.5Z",
    fill: "#EB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.776 331.977H613.89V498.698H388.776V331.977Z",
    fill: "#D04A02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.89 10.2278H962.046V498.698H613.89V10.2278Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0996 498.698H501.333V1042.75H12.0996V498.698Z",
    fill: "#EB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.333 498.698H613.89V1042.75H501.333V498.698Z",
    fill: "#D04A02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.89 498.698H962.046V807.284H613.89V498.698Z",
    fill: "#DB536A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.89 807.282H787.968V1042.75H613.89V807.282Z",
    fill: "#EB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.41 884.815V1033.22H1748.13V884.815H1318.41ZM797.751 816.116V1033.22H950.788V816.116H797.751ZM623.771 816.116V1033.22H777.5V816.116H623.771ZM1543.21 729.763V867.065H1748.13V729.763H1543.21ZM1318.41 729.763V867.065H1522.96V729.763H1318.41ZM1768.38 563.768V1033.22H1900.73V563.781H1768.38V563.768ZM1543.21 563.768V712.013H1748.13V563.768H1543.21ZM1318.41 563.768V712.013H1522.96V563.768H1318.41ZM971.056 563.768V1033.22H1298.16V563.781H971.056V563.768ZM623.785 506.998V798.366H950.8V506.998H623.785ZM511.285 506.998V1033.22H603.517V507.011H511.285V506.998ZM20.3656 506.998V1033.22H491.031V507.011H20.3666L20.3656 506.998ZM399.276 341.277V489.262H603.531V341.277H399.276ZM175.02 341.277V489.262H379.008V341.277H175.02ZM971.056 253.924V546.031H1298.16V253.924H971.056ZM399.276 186.243V323.54H603.531V186.243H399.276ZM175.02 186.243V323.54H379.008V186.243H175.02ZM1431.82 17.7359V546.045H1900.75V17.7359H1431.82ZM1318.42 17.7359V546.045H1411.57V17.7359H1318.42ZM1144.36 17.7359V236.187H1298.17V17.7359H1144.36ZM971.07 17.7359V236.187H1124.11V17.7359H971.07ZM623.799 17.7359V489.277H950.816V17.7359H623.799ZM175.034 17.7359V168.501H603.517V17.7359H175.034ZM20.3666 17.7359V489.277H154.767V17.7359H20.3666ZM950.8 0H1921.01V1052.97H0.0996094V0H950.8Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.41 884.815V1033.22H1748.13V884.815H1318.41ZM797.751 816.116V1033.22H950.788V816.116H797.751ZM623.771 816.116V1033.22H777.5V816.116H623.771ZM1543.21 729.763V867.065H1748.13V729.763H1543.21ZM1318.41 729.763V867.065H1522.96V729.763H1318.41ZM1768.38 563.768V1033.22H1900.73V563.781H1768.38V563.768ZM1543.21 563.768V712.013H1748.13V563.768H1543.21ZM1318.41 563.768V712.013H1522.96V563.768H1318.41ZM971.056 563.768V1033.22H1298.16V563.781H971.056V563.768ZM623.785 506.998V798.366H950.8V506.998H623.785ZM511.285 506.998V1033.22H603.517V507.011H511.285V506.998ZM20.3656 506.998V1033.22H491.031V507.011H20.3666L20.3656 506.998ZM399.276 341.277V489.262H603.531V341.277H399.276ZM175.02 341.277V489.262H379.008V341.277H175.02ZM971.056 253.924V546.031H1298.16V253.924H971.056ZM399.276 186.243V323.54H603.531V186.243H399.276ZM175.02 186.243V323.54H379.008V186.243H175.02ZM1431.82 17.7359V546.045H1900.75V17.7359H1431.82ZM1318.42 17.7359V546.045H1411.57V17.7359H1318.42ZM1144.36 17.7359V236.187H1298.17V17.7359H1144.36ZM971.07 17.7359V236.187H1124.11V17.7359H971.07ZM623.799 17.7359V489.277H950.816V17.7359H623.799ZM175.034 17.7359V168.501H603.517V17.7359H175.034ZM20.3666 17.7359V489.277H154.767V17.7359H20.3666ZM950.8 0H1921.01V1052.97H0.0996094V0H950.8Z",
    fill: "#FFB600"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_5876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 759,
    height: 1052,
    rx: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_183_5876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1052,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/Pattern.bb92054853e1d8847667c4b929dbce44.svg";
export { ForwardRef as ReactComponent };